import { Component, OnInit } from '@angular/core';
import { InvoiceReportService } from '../../services/invoices-report.service';
import { Observable } from 'rxjs/Observable';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-invoices',
  templateUrl: './list-invoices.component.html',
  styleUrls: ['./list-invoices.component.css'],
  providers:[InvoiceReportService]
})
export class ListInvoicesComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  invoices:any = [];
  filters:any = {
    invoice_number:{contains: ""},
    customer_nif: {contains: ""},
    customer_name: {contains: ""},
    type: {contains: ""},
    ticket: {contains: ""}
  };
  exportParams:any ={};
  showExportButton:boolean = true;
  from:any;
  until:any;
  role:number = 3;

  constructor(private invoiceReportService:InvoiceReportService) { }

  ngOnInit() {
    this.getInvoices();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getInvoices(){
    let params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.from && moment(this.from, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.from, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.until && moment(this.until, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.until, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    this.exportParams = params;
    this.invoiceReportService.query(params)
               .subscribe((invoices) => {
                  let countParams = {
                    where: _.cloneDeep(params.where),
                  };
                  this.invoiceReportService.count(countParams)
                  .subscribe((count) => {
                    this.totalItems = count.count;
                  });
                  this.invoices = invoices;
                });
    }


    exportInvoicesToExcel(){
      this.showExportButton = false;
      var options = {   
          fieldSeparator: ';',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: false,
          showTitle: false,
          useBom: false,   
          bookType:'xlsx' ,  
          cellStyles:true,
      };             
      let report = [
            {
                field1:"Nº de Factura",
                field2:"Tipo",
                field3:"Ticket",
                field4:"Fecha",
                field5:"NIF Cliente",
                field6:"Nombre Cliente",
                field7:"Articulos",
                field8:"Impuesto (%)",
                field9:"Base Imponible",
                field10:"Total Factura",
                field11:"Método de pago",
                
            }
        ]
        delete this.exportParams.skip;
        delete this.exportParams.limit;
        let observablePurchasesRequest = [];
        let request = Math.ceil(this.totalItems / 100);
        for (let i=0; i<request;i++){
          this.exportParams.skip = ((i)*100),
          this.exportParams.limit = 100;
          observablePurchasesRequest.push(this.invoiceReportService.query(this.exportParams));
        }
        Observable.forkJoin(observablePurchasesRequest)
            .subscribe(data => {
              let p:any = data;
              let invoices = p.flat(); 
              invoices.forEach(invoice =>{
                  var row = {
                      field1:invoice.invoice_number?invoice.invoice_number:"",
                      field2:invoice.type?invoice.type:"",
                      field3:invoice.ticket?invoice.ticket:"",
                      field4:invoice.date?moment(invoice.date).format("DD-MM-YYYY"):"",
                      field5:invoice.customer_nif?invoice.customer_nif:"",
                      field6:invoice.customer_name?invoice.customer_name:"",
                      field7:invoice.products?invoice.products:"",
                      field8:invoice.tax?invoice.tax:"",
                      field9:invoice.total_net?invoice.total_net:"",
                      field10:invoice.total_amount?invoice.total_amount:"",
                      field11:invoice.method_of_payment?invoice.method_of_payment:"",
                  }
                  report.push(row);
              });
                  var mystyle = {   
                      headers:true,       
                      columns:    
                          [{columnid:'field1',width:100,title: ''},   
                          {columnid:'field2',width:100,title: ''},
                          {columnid:'field3',width:100,title: 'LISTADO DE COMPRAS'},
                          {columnid:'field4',width:100,title: ''},
                          {columnid:'field5',width:100,title: ''},
                          {columnid:'field6',width:100,title: ''},
                          {columnid:'field7',width:300,title: ''},
                          {columnid:'field8',width:100,title: ''},
                          {columnid:'field9',width:100,title: ''},
                          {columnid:'field10',width:100,title: ''},
                          {columnid:'field11',width:100,title: ''},
                          
                          ],
                      /*header*/
                    
                      column: {  
                          style:{
                              Alignment:{
                                  Horizontal:"Center",
                                  Vertical:"Center",  
                                  WrapText:1
                                  
                              },
                              Font:{
                                  Bold:"1",
                                  Color:"#000000",
                                  Size:10
                              },
                              
                              Interior:{
                                  Color:"#7CEECE",
                                  Pattern:"Solid"
                              }
                          }},
                    cells: {    
                          0:{
                              0:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid",
                                          },
                                  Alignment:{
                                    Horizontal:"Center",
                                    Vertical:"Center",
                                    WrapText: 1,
                                      },  
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                                  },                        
                                  }  
                              },
                              1:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                              },  
                                  Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },            
                                      }
                              },
                              2:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                          }, 
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              }                
                                      }
                                  },
                              3:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1,
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                        
                                      }
                                  },
                              4:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                           
                                      }
                                  },
                              5:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                  },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                           
                                      }
                                  }, 
                              6:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                  },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                             
                                  }
                                  }, 
                                  7:{style:{
                                      Interior:{ 
                                          Color:"#95a5a6",
                                          Pattern:"Solid"
                                                  },
                                      Alignment:{
                                          Horizontal: 'Center', 
                                          Vertical: 'Center',
                                          WrapText: 1, 
                                      },
                                      Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },                             
                                      }
                                      },
                                      8:{style:{
                                          Interior:{ 
                                              Color:"#95a5a6",
                                              Pattern:"Solid"
                                                      },
                                          Alignment:{
                                              Horizontal: 'Center', 
                                              Vertical: 'Center',
                                              WrapText: 1, 
                                          },
                                          Font:{
                                              Size:10,
                                              Bold:"1",
                                              Color:"#000000",
                                      },                             
                                          }
                                          },
                                          9:{style:{
                                              Interior:{ 
                                                  Color:"#95a5a6",
                                                  Pattern:"Solid"
                                                          },
                                              Alignment:{
                                                  Horizontal: 'Center', 
                                                  Vertical: 'Center',
                                                  WrapText: 1, 
                                              },
                                              Font:{
                                                  Size:10,
                                                  Bold:"1",
                                                  Color:"#000000",
                                          },                             
                                              }
                                              },
                                              10:{style:{
                                                  Interior:{ 
                                                      Color:"#95a5a6",
                                                      Pattern:"Solid"
                                                              },
                                                  Alignment:{
                                                      Horizontal: 'Center', 
                                                      Vertical: 'Center',
                                                      WrapText: 1, 
                                                  },
                                                  Font:{
                                                      Size:10,
                                                      Bold:"1",
                                                      Color:"#000000",
                                              },                             
                                                  }
                                                  },
                          }   
                    },
            };
            this.showExportButton = true;
            alasql.promise('SELECT * INTO XLSXML("Facturas'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
            .then(function(data){
                console.log('Data saved');
            }).catch(function(err){
                console.log('Error:', err);
            });
          });
    }

}



// WEBPACK FOOTER //
// ./src/app/reports/components/list-invoices/list-invoices.component.ts